import React, { createContext, useContext, useState, useCallback } from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const NotificationsContext = createContext(null);

export function NotificationsProvider({ children }) {
  const [notifications, setNotifications] = useState([]);

  // Ajouter une notification
  const addNotification = useCallback((notification) => {
    // notification: { type, message, title, delay }
    const id = Date.now() + Math.random();
    const {
      type = "info", // "success" | "error" | "warning" | "info"
      message = "",
      title = "",
      delay = 5000,
    } = notification;

    const newNotif = { id, type, message, title, delay };
    setNotifications((prev) => [...prev, newNotif]);
  }, []);

  // Supprimer une notification
  const removeNotification = useCallback((id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }, []);

  const value = {
    addNotification,
  };

  const variantForType = (type) => {
    if (type === "success") return "success";
    if (type === "error") return "danger";
    if (type === "warning") return "warning";
    return "info";
  };

  const textClassForType = (type) =>
    type === "warning" || type === "info" ? "text-dark" : "text-white";

  return (
    <NotificationsContext.Provider value={value}>
      {children}
      {/* Conteneur global des toasts */}
      <ToastContainer
        position="top-end"
        className="p-3"
        style={{ zIndex: 9999 }}
      >
        {notifications.map((notif) => (
          <Toast
            key={notif.id}
            bg={variantForType(notif.type)}
            onClose={() => removeNotification(notif.id)}
            delay={notif.delay}
            autohide
          >
            {notif.title && (
              <Toast.Header closeButton>
                <strong className="me-auto">{notif.title}</strong>
              </Toast.Header>
            )}
            <Toast.Body className={textClassForType(notif.type)}>
              {notif.message}
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </NotificationsContext.Provider>
  );
}

// Hook pour utiliser facilement les notifications
export function useNotifications() {
  const ctx = useContext(NotificationsContext);
  if (!ctx) {
    throw new Error(
      "useNotifications doit être utilisé à l'intérieur de <NotificationsProvider>"
    );
  }
  return ctx;
}
